import { COURSE_CONFIG } from '../types';

/**
 * Certificate template keys in `src/types.ts` — not auto-inserted into `courses` anymore.
 * Manage sellable courses in Admin → Courses (database only).
 */
export const COURSE_CATALOG_NAMES = Object.keys(COURSE_CONFIG) as readonly string[];

export type CourseCatalogName = keyof typeof COURSE_CONFIG;
